import styles from './addScenariosToTestPlanModal.module.scss';
import { Checkbox } from "../../shared/components/checkbox/checkbox";
import {
  useEffect,
  useState
} from "react";
import { useTranslation } from "react-i18next";
import { Scenario } from "../../types/scenarioTypes";
import { useGetAllScenariosQuery } from "../../api/scenarioService";
import { SearchInput } from "../../shared/components/searchInput/searchInput";
import { ModalWindow } from "../../shared/components/modalWindow/modalWindow";

type AddScenariosToTestPlanModalProps = {
  onClose: (isSave: boolean, selectedScenarios?: Array<Scenario>) => void;
  testPlanName: string;
}

export const AddScenariosToTestPlanModal = ({ onClose, testPlanName }: AddScenariosToTestPlanModalProps) => {
  const { t } = useTranslation();

  const [selectedScenarios, setSelectedScenarios] = useState<Array<Scenario>>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [filteredScenarios, setFilteredScenarios] = useState<Array<Scenario>>([]);

  const { data: scenarios } = useGetAllScenariosQuery("");

  useEffect(() => {
    if (!!scenarios) {
      setFilteredScenarios(scenarios);
      setSearchValue("");
    }
  }, [scenarios]);

  useEffect(() => {
    if (!!scenarios) {
      setFilteredScenarios(scenarios.filter(item => item.name.toLowerCase().includes(searchValue.toLowerCase())));
    }
  }, [searchValue, scenarios]);

  const onChangeSelect = (scenario: Scenario) => {
    const newArray = [...selectedScenarios];
    const index = newArray.findIndex(item => item.id === scenario.id);
    const needRemove = index > -1;
    if (needRemove) {
      newArray.splice(index, 1);
    } else {
      newArray.push(scenario);
    }

    setSelectedScenarios(newArray);
  }

  const isSelected = (scenario: Scenario): boolean => {
    const findItem = selectedScenarios.find(item => item.id === scenario.id);
    return !!findItem;
  }

  const onClickAdd = () => {
    onClose(true, selectedScenarios);
  }

  return (
    <ModalWindow onClose={() => onClose(false)}
                 width={418}
                 showTooltip={true}
                 title={`${t("testPlan.addScenarioTo")} '${testPlanName}'`}
                 children={
                   <div className={styles.container}>
                     <div className={styles.search}>
                       <SearchInput value={searchValue} onChange={setSearchValue}/>
                     </div>
                     <div className={styles.scenarios}>
                       {filteredScenarios.map(testCase => ((
                         <div key={testCase.id}
                              className={`${styles.testCase} ${isSelected(testCase) ? styles.selected : ""}`}
                              onClick={() => onChangeSelect(testCase)}>
                           <span>{testCase.name}</span>
                           <Checkbox isChecked={selectedScenarios.includes(testCase)}/>
                         </div>
                       )))}
                     </div>
                     <div className={styles.buttons}>
                       <button className={styles.cancel} onClick={() => onClose(false)}>{t("common.cancel")}</button>
                       <button className={styles.save} onClick={onClickAdd}>{t("common.add")}</button>
                     </div>
                   </div>
                 }
    />

  )
}